import { TABLE_IDS } from '@/legacy/constants';
import { usePrefetchTable } from '../../table/hooks';
import urls from '@/legacy/config/env';

export const usePrefetchUsersTable = () =>
	usePrefetchTable({
		pageKey: 'app__users__app_users',
		tableId: TABLE_IDS.ALL_USERS,
		endpoint: urls.users.allUsersTable,
		sortBy: 'money_balance',
	});
